import axios from './axios';

const path = (type, id) => `/api/translations/${encodeURIComponent(type)}/${encodeURIComponent(id)}/en`;
export const getTranslation = (type, id) => axios.get(path(type, id)).then(response => response.data);
export const saveTranslationDraft = (type, id, payload) => axios.put(`${path(type, id)}/draft`, payload).then(response => response.data);
export const publishTranslation = (type, id, payload) => axios.post(`${path(type, id)}/publish`, payload).then(response => response.data);
export const withdrawTranslation = (type, id, payload) => axios.post(`${path(type, id)}/withdraw`, payload).then(response => response.data);
